<template>
  <b-row>
    <b-col >
      <h2 class="text-center m-text"> Redirecionando para a loja do app <b>{{ formatUrl(url) }}</b> . . .</h2>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ShareProductApp',
  
  data(){
    return {
      url: '',
      isApple: false
    }
  }, 
  
  mounted() {
    this.noApp()
  },

  methods: {
    noApp(){
      this.$store.dispatch('startLoader');
      const header = document.getElementsByClassName('header');
      const footer = document.getElementsByClassName('footer')
      header[0].setAttribute('class', 'd-none')
      footer[0].setAttribute('class', 'd-none')

      const idShopkeeper = this.$route.params.shopkeeper;
      const info = window.navigator.userAgent.toLocaleLowerCase()

      if(info.includes('iphone') || 
          info.includes('macintosh') ||
          info.includes('ipad') ||
          info.includes('mac')
      ){
        this.isApple = true;
      }  
      
      this.$store.dispatch('gerente/buscarLinksId', idShopkeeper)
        .then((response) => {
          if(this.isApple){
            this.url = response.data.link_apple;
          } else {
            this.url = response.data.link_android;
          }
          window.location.href = this.url;
        })
        .catch()
        .finally(() => this.$store.dispatch('endLoader'));
    }, 
    formatUrl(url){
      const text = url.split('?id=br.com.').pop();
      return text;
    }
  }
}
</script>

<style scoped>
.m-text {
  margin-top: 23%;
}
</style>
